module.exports = __webpack_public_path__ + "fonts/font.0f3f913.woff2";